<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span><em name="Exhibition"></em><span>/</span>
          <a href="javascript:history.back()">Press Release</a><span>/</span>Edit Press Release
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->

    <article>
      <div class="contentBox">
        <div>
          <div class="container">
            <h1>Edit Press Release</h1>

            <p class="my-3">&nbsp;</p>
            <p class="alert">
              Do not upload content that is irrelevant to this exhibition. The organizer reserves the right to delete
              inappropriate content.
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="EditEnVideo">
              <p class="formTitle">Display <span class="red">*</span></p>
              <label
                ><input type="radio" name="Archived" value="0" v-model="NewsData.Archived" class="largeItem true" />
                Show</label
              >
              <label
                ><input
                  type="radio"
                  name="Archived"
                  value="1"
                  v-model="NewsData.Archived"
                  class="largeItem false ml-2"
                />
                Hide</label
              >
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Topic <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  v-model="NewsData.eNewsTopic"
                  maxlength="100"
                  placeholder="Max of 100 characters allowed."
                />
                <span>EN</span>
              </div>
              <div id="error2"></div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="NewsTopic"
                  class="maxText textStyle"
                  maxlength="50"
                  v-model="NewsData.NewsTopic"
                  placeholder="Max of 50 characters allowed."
                />
                <span>中</span>
              </div>
              <p class="my-3">&nbsp;</p>

              <p class="formTitle">Link</p>

              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  maxlength="200"
                  v-model="NewsData.eNewsUrl"
                />
                <span>EN</span>
              </div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="NewsTopic"
                  class="maxText textStyle"
                  maxlength="200"
                  v-model="NewsData.NewsUrl"
                />
                <span>中 </span>
              </div>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Press Release Content (English)<span class="red">*</span></p>
              <ckeditor v-model="NewsData.eNewsContent" :config="editorConfig"></ckeditor>

              <div id="error"></div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Press Release Content (Chinese)</p>
              <ckeditor v-model="NewsData.NewsContent" :config="editorConfig"></ckeditor>
              <p class="my-3">&nbsp;</p>
              <div class="d-flex justify-content-center">
                <input type="submit" value="Confirm" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backNewsPage">Back</div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: `Press Release - Chan Chao Exhibitor's Online Service System`,
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        NewsId: '',
        NewsData: [],
        lang: 'en',
      }
    },

    methods: {
      EditVideo() {
        const vm = this

        if (!vm.NewsData.NewsTopic || !vm.NewsData.NewsContent) {
          $('html,body').animate({ scrollTop: 0 }, 'slow')

          alert('輸入欄位不完整，請重新檢查！')

          if (!vm.NewsData.NewsTopic) {
            $('#error2').html("<span class='errorTextArea'>請填寫此欄位</span>")
            $('#error').html("<p class='errorTextArea'></p>")

            if (!vm.NewsData.NewsContent) {
              $('#error').html("<p class='errorTextArea'>請填寫此欄位</p>")
            }
          } else {
            $('#error2').html("<span class='errorTextArea'></span>")
            $('#error').html("<p class='errorTextArea'>請填寫此欄位</p>")
          }
        } else {
          if (!vm.NewsData.NewsContent) {
            alert('輸入欄位不完整，請重新檢查！')
            $('#error').html("<p class='errorTextArea'>請填寫此欄位</p>")
          } else {
            const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`

            const info = {
              NewsTopic: vm.NewsData.NewsTopic,
              eNewsTopic: vm.NewsData.eNewsTopic,
              NewsUrl: vm.NewsData.NewsUrl,
              eNewsUrl: vm.NewsData.eNewsUrl,
              NewsContent: vm.NewsData.NewsContent,
              eNewsContent: vm.NewsData.eNewsContent,
              Archived: vm.NewsData.Archived,
              CSRF: vm.CSRF_Token,
            }

            // console.log(info)

            axios.post(url, info).then(function (response) {
              // console.log(response)
              if (response.data.Code == 200) {
                alert('您已成功修改新聞稿內容！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('系統忙碌，請稍後再試！')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      EditEnVideo() {
        const vm = this

        if (!vm.NewsData.eNewsTopic || !vm.NewsData.eNewsContent) {
          $('html,body').animate({ scrollTop: 0 }, 'slow')

          alert('There are incomplete fields, please check again.')

          if (!vm.NewsData.eNewsTopic) {
            $('#error2').html("<span class='errorTextArea'>This field is required.</span>")
            $('#error').html("<p class='errorTextArea'></p>")

            if (!vm.NewsData.eNewsContent) {
              $('#error').html("<p class='errorTextArea'>This field is required.</p>")
            }
          } else {
            $('#error2').html("<span class='errorTextArea'></span>")
            $('#error').html("<p class='errorTextArea'>This field is required.</p>")
          }
        } else {
          if (!vm.NewsData.eNewsContent) {
            alert('There are incomplete fields, please check again.')
            $('#error').html("<p class='errorTextArea'>This field is required.</p>")
          } else {
            const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`

            const info = {
              NewsTopic: vm.NewsData.NewsTopic,
              eNewsTopic: vm.NewsData.eNewsTopic,
              NewsUrl: vm.NewsData.NewsUrl,
              eNewsUrl: vm.NewsData.eNewsUrl,
              NewsContent: vm.NewsData.NewsContent,
              eNewsContent: vm.NewsData.eNewsContent,
              Archived: vm.NewsData.Archived,
              CSRF: vm.CSRF_Token,
            }

            axios.post(url, info).then(function (response) {
              // console.log(response)
              if (response.data.Code == 200) {
                alert('Successfully changed your news information!')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`
              } else if (response.data.Code == 251 || response.data.Code == 500) {
                alert('System is busy, please try again later.')
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`
              } else if (response.data.Code == 252) {
                document.location.href = `https://www.chanchao.com.tw/`
              }
            })
          }
        }
      },

      backNewsPage() {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`
        }
      },
    },

    created() {
      const vm = this

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
        //   alert(vm.CSRF_Token)
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]

      //取出url裡的NewsId
      vm.NewsId = currentUrl.split('id=')[1]

      //取得特定新聞稿
      let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${vm.NewsId}`
      axios
        .get(url)
        .then(function (response) {
          // console.log(response)

          if (response.data.Data) {
            vm.NewsData = response.data.Data
          } else {
            alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`
          }
        })
        .catch((err) => {
          alert('Unavailable URL 網址連結有誤，將自動為您重新導向！')
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`
        })
    },
  }
</script>

<style lang="scss"></style>
